<template>
  <div class="tabs_content" id="tab">
    <section>
      <div class="left">
        <DetailEntityInfo
            :entity="entity"
        />
      </div>
      <div class="right">
        <role-groups-basic-form
            :entity="entity"
            :is-editable="!entity.global && $_updateActionAllowed"
            ref="roleGroupsBasicFormRef"
        />
        <role-groups-select-list
            v-model="entity.roles"
            :is-editable="!entity.global && $_updateActionAllowed"
            :edit-allowed-sections="edit_allowed_section_list"
            ref="roleGroupsBasicFormRef"
        />
      </div>
    </section>
  </div>
</template>

<script>
import RoleGroupsBasicForm from "./../forms/RoleGroupsBasicForm";
import RoleGroupsSelectList from "./../forms/RoleGroupsSelectList";
import DetailEntityInfo from "../../../common/DetailEntityInfo";

export default {
  name: "BasicInfo",
  components: {RoleGroupsBasicForm, RoleGroupsSelectList, DetailEntityInfo},
  props: {
    entity: Object,
    edit_allowed_section_list: Array
  }
};
</script>



// WEBPACK FOOTER //
// src/components/views/roleGroups/detail/BasicInfo.vue